/* MUSLIMFY - Cart Drawer Upsell handler
 *
 * Intercepte le submit des forms <form data-mfy-upsell-form> dans le bandeau
 * upsell du cart drawer. Fait un AJAX POST /cart/add.js puis refresh le drawer
 * via Section Rendering API (la section sections/cart-drawer.liquid est un
 * wrapper qui render le snippet cart-drawer.liquid - ideal pour le refresh).
 *
 * Flow :
 *   1. submit intercept -> preventDefault
 *   2. button -> disabled + label "..."
 *   3. fetch POST /cart/add.js avec variant_id + quantity
 *   4. Si OK -> button "Ajoute !" 1s puis refresh drawer
 *   5. Si erreur -> button rouge "Indispo" 2s puis reset
 *
 * Delegation event sur document : survit aux replacements DOM du cart drawer
 * (qui sont fait par le refresh lui-meme).
 */
(function () {
  'use strict';

  var ROUTE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var inFlight = false;

  function setBtnState(btn, state, label) {
    if (!btn) return;
    if (state) btn.setAttribute('data-state', state);
    else btn.removeAttribute('data-state');
    if (label != null) btn.textContent = label;
  }

  async function refreshCartDrawer() {
    try {
      // Accept: application/json -> garantit que Shopify renvoie le JSON
      // { "cart-drawer": "<html>..." } et pas la page HTML complete.
      var resp = await fetch(ROUTE + '?sections=cart-drawer', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      if (!resp.ok) throw new Error('section fetch HTTP ' + resp.status);
      var data = await resp.json();
      var newDrawerHtml = data['cart-drawer'];
      if (!newDrawerHtml) throw new Error('section cart-drawer absent du JSON');

      // Parse le response
      var parser = new DOMParser();
      var doc = parser.parseFromString(newDrawerHtml, 'text/html');

      // Cherche le <cart-drawer> dans le response (peut etre wrappe ou non).
      // Section Rendering API renvoie soit :
      //   - <div id="shopify-section-cart-drawer"><cart-drawer>...</cart-drawer></div>  (avec schema)
      //   - <cart-drawer>...</cart-drawer>  (sans schema, fallback)
      var newDrawer = doc.querySelector('cart-drawer');
      if (!newDrawer) throw new Error('cart-drawer custom element absent du HTML reponse');

      // Cherche l'existant dans le DOM courant (robuste : pas dependant du wrapper section)
      var oldDrawer = document.querySelector('cart-drawer');
      if (!oldDrawer) throw new Error('cart-drawer absent du DOM courant');

      // Preserver l'etat ouvert AVANT le replace (sinon le drawer se ferme apres add)
      var wasActive = oldDrawer.classList.contains('active');
      var wasOpen   = oldDrawer.hasAttribute('open');
      var bodyOpened = document.body.classList.contains('drawer-opened');

      oldDrawer.replaceWith(newDrawer);

      // Re-applique l'etat ouvert (le nouveau drawer est ferme par defaut)
      if (wasActive) newDrawer.classList.add('active');
      if (wasOpen)   newDrawer.setAttribute('open', '');
      if (bodyOpened) document.body.classList.add('drawer-opened');

      // Trigger events pour les composants qui ecoutent (cart icon bubble, etc.)
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      } catch (e) { /* fallback browsers anciens */ }
    } catch (e) {
      if (window.console) console.warn('[MFY/Upsell] refresh drawer failed:', e.message);
      // Fallback : reload de la page (l'item EST ajoute, c'est juste l'UI qui n'est pas a jour)
      window.location.reload();
    }
  }

  async function onSubmit(form, btn) {
    if (inFlight) return;
    inFlight = true;
    var originalLabel = btn ? btn.textContent : '';
    setBtnState(btn, null, '...');
    if (btn) btn.disabled = true;

    try {
      var formData = new FormData(form);
      var resp = await fetch(ROUTE + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      if (!resp.ok) {
        var body = await resp.json().catch(function () { return {}; });
        var msg = body.description || body.message || ('HTTP ' + resp.status);
        throw new Error(msg);
      }

      // Add OK : button vert + refresh drawer
      setBtnState(btn, 'added', 'Ajoute !');
      await refreshCartDrawer();
      // Le refresh va REMPLACER le DOM donc le btn original disparait.
      // Pas besoin de reset manuel.
    } catch (e) {
      if (window.console) console.warn('[MFY/Upsell] add failed:', e.message);
      setBtnState(btn, 'error', 'Indispo');
      setTimeout(function () {
        setBtnState(btn, null, originalLabel);
        if (btn) btn.disabled = false;
      }, 2000);
    } finally {
      inFlight = false;
    }
  }

  // Delegation au niveau document -> survit aux replacements DOM du cart drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-mfy-upsell-form]')) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[data-mfy-upsell-btn]');
    onSubmit(form, btn);
  }, true); // capture phase pour intercepter avant les autres handlers
})();
